import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Scissor Inn · Your Hair, Our Passion</p>
        <h1>Welcome to Scissor Inn!</h1>
        <p className="lede">
          Experience top-notch hair care and styling services tailored just for you. Our skilled professionals are dedicated to making you look and feel your best.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Services
          </a>
          <a href="/book" target="_blank" className="secondary">
            Book Your Appointment
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Stylists</h2>
          <p>
            Our team of experienced stylists is here to provide personalized consultations and exceptional hair services that suit your unique style.
          </p>
        </article>
        <article>
          <h2>Relaxing Atmosphere</h2>
          <p>
            Enjoy a calming environment designed for your comfort. At Scissor Inn, we prioritize your relaxation while you receive our premium services.
          </p>
        </article>
        <article>
          <h2>Quality Products</h2>
          <p>
            We use only the best hair care products to ensure your hair looks stunning and stays healthy long after you leave our salon.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;